import { ButtonFilled } from '@abtasty/design-system';
import { ButtonFilledProps } from '@abtasty/design-system/dist/components/Button/ButtonFilled/ButtonFilled';
import { forwardRef } from 'react';
import { styled } from 'styled-components';

const FullWidthButton = styled(ButtonFilled)`
  width: 100%;
  max-width: inherit !important;
`;

export const MobileDetailsButton = forwardRef<HTMLElement, Omit<ButtonFilledProps, 'size' | 'iconPosition'>>(
  (props) => <FullWidthButton {...props} size="medium" iconPosition="left" />
);
